<div *ngIf="isLoading | async">
  <div *ngIf="type === 'text'">
    <ngx-skeleton-loader count="{{ count }}" [theme]="{ 'border-radius': '5', width: renderThemeWidth(), height: height + 'px' }"></ngx-skeleton-loader>
  </div>
  <div *ngIf="type === 'image'">
    <ngx-skeleton-loader count="{{ count }}" [theme]="{ 'border-radius': '8', height: '48px', width: '48px' }"></ngx-skeleton-loader>
  </div>
  <div *ngIf="type === 'btn'">
    <ngx-skeleton-loader count="{{ count }}}" [theme]="{ 'border-radius': '5', height: '40px', width: '100px' }"></ngx-skeleton-loader>
  </div>
  <div *ngIf="type === 'icon'">
    <ngx-skeleton-loader count="{{ count }}" [theme]="{ 'border-radius': '1', height: height + 'px', width: (width ? width : '20') + 'px' }"></ngx-skeleton-loader>
  </div>
  <div *ngIf="type === 'icon-and-text'">
    <div class="d-flex flex-wrap text-gray-700">
      <div class="d-flex align-items-center me-6" *ngFor="let number of numbers">
        <ngx-skeleton-loader class="me-5" count="1" [theme]="{ 'border-radius': '1', height: '20px', width: '20px' }"></ngx-skeleton-loader>
        <ngx-skeleton-loader count="1" [theme]="{ 'border-radius': '5', height: height + 'px', width: width + 'px' }"></ngx-skeleton-loader>
      </div>
    </div>
  </div>

  <div *ngIf="type === 'text-and-text'">
    <div class="row" *ngFor="let number of numbers" [class.mb-7]="!fluidSize">
      <label class="col-12 col-md-3">
        <ngx-skeleton-loader count="1" [theme]="{ 'border-radius': '5', height: height + 'px', width: renderThemeWidth() }"></ngx-skeleton-loader>
      </label>
      <div class="col-12 col-md-9">
        <ngx-skeleton-loader count="1" [theme]="{ 'border-radius': '5', height: height + 'px', width: renderThemeWidth() }"></ngx-skeleton-loader>
      </div>
    </div>
  </div>

  <div *ngIf="type === 'text-and-image'">
    <div class="row mb-7">
      <div class="col-lg-6" *ngFor="let number of numbers">
        <div class="row">
          <label class="col-lg-4">
            <ngx-skeleton-loader count="1" [theme]="{ 'border-radius': '5', height: height + 'px', width: '150px' }"></ngx-skeleton-loader>
          </label>
          <div class="col-lg-8">
            <ngx-skeleton-loader count="1" [theme]="{ 'border-radius': '8', height: '250px', width: '250px' }"></ngx-skeleton-loader>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="(isLoading | async) === false">
  <ng-content></ng-content>
</div>
